@if ((dragFromGroupLevelAllowed && dragAndDropAllowed)) {
  <div
    cdkDropList
    [cdkDropListConnectedTo]="gridList"
    class="cursor-pointer d-flex align-items-center border-bottom position-relative bg-blue-gray border-white bg-blue-gray-hover catalogue-product-item"
    [ngClass]="{'disabled-type': disabledTitle || dragGroupNotAllowed, 'opacity-6': !dragAndDropAllowed }" (click)="toggleAccordion()">
    <div class="kits-image border-right">
      @if (groupImage) {
        <img [src]="groupImage" alt="image" width="50" class="m-1 transparent-image">
      }
    </div>
    <div class="mr-auto"><p class="pb-2 pt-2 pl-3 pr-3 m-0 kits-title break-title-in-div">{{title}}</p></div>
    <span class="float-right pr-2 iconWidth">
      <i class="icon24 se-icon float-right">{{isOpened ? 'arrow2_up' : 'arrow2_down'}}</i>
    </span>
    <div
      class="w-100 h-100 position-absolute drag-element"
      cdkDrag
      [cdkDragData]="dragData"
      (cdkDragMoved)="dragElementOnGrid($event)"
      (cdkDragEnded)="dragEnd()">
      <img *cdkDragPreview alt="" [src]="dragData?.picture2D" class="bg-gray p-0" [width]="groupImagePreviewDimensions?.width">
    </div>
  </div>
} @else {
  @if (!hideTitle) {
    <div class="cursor-pointer d-flex align-items-center border-bottom no-select bg-blue-gray border-white bg-blue-gray-hover"
      [ngClass]="{'disabled-type': disabledTitle || dragGroupNotAllowed, 'opacity-6': !dragAndDropAllowed }" (click)="toggleAccordion()">
      <div class="kits-image border-right">
        @if (groupImage) {
          <img [src]="groupImage" alt="image" width="50" class="m-1 pointer-events-none transparent-image">
        }
      </div>
      <div class="mr-auto"><p class="display-inline-block pb-2 pt-2 pl-3 pr-3 m-0 kits-title">{{title}}</p>
      @if (showBadgeNew) {
        <span i18n="@@app.new" class="mb-2 ml-3 badge badge-pill font-weight-600 badge-new">New</span>
      }
    </div>
    <span class="float-right pr-2">
      <i class="icon24 se-icon float-right">{{isOpened ? 'arrow2_up' : 'arrow2_down'}}</i>
    </span>
  </div>
}
}


<div #element class="content overflow-hidden {{contentClassName}}">
  <ng-content></ng-content>
</div>
